import axiosClient from './axiosClient'
import { GET_FILE_API, GET_MULTIPLE_FILES_API } from '~/constants/APIs/files'

export const fileApis = {
  getFile: (sufi: number) =>
    axiosClient.get(GET_FILE_API + sufi, { responseType: 'blob' }),

  getMultipleFiles: (sufis: number[]) =>
    axiosClient.get(GET_MULTIPLE_FILES_API, { params: { sufis }, responseType: 'blob' })
}
